import React from 'react';
export function App() {
  return <div className="min-h-screen w-full bg-neutral-900 flex items-center justify-center p-4 sm:p-8" data-id="element-0">
      {/* Injecting fonts and custom animations directly to keep it single-file */}
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&display=swap');

        .font-serif-custom {
          font-family: 'Playfair Display', serif;
        }
        
        .font-sans-custom {
          font-family: 'Inter', sans-serif;
        }

        @keyframes fadeDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-down {
          animation: fadeDown 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .animate-fade-up {
          animation: fadeUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        .delay-200 { animation-delay: 200ms; }
        .delay-500 { animation-delay: 500ms; }
        .delay-700 { animation-delay: 700ms; }
      `}</style>

      {/* Mobile Device Container */}
      <div className="relative w-full max-w-[430px] aspect-[9/16] rounded-[2.5rem] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] ring-1 ring-white/10 bg-black" data-id="element-2">
        {/* Background Image */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[10s] ease-out hover:scale-105" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/fssDqUwV3HFn9mT4oBtPQ6/CONEXION_NUEVO_1.png')`
      }} data-id="element-3" />

        {/* Top Gradient Overlay (Dark to Transparent) */}
        <div className="absolute top-0 inset-x-0 h-[40%] bg-gradient-to-b from-black/70 via-black/30 to-transparent pointer-events-none" data-id="element-4" />

        {/* Bottom Gradient Overlay (Transparent to Warm Dark) */}
        <div className="absolute bottom-0 inset-x-0 h-[45%] bg-gradient-to-t from-[#3A261D]/95 via-[#5C3D2E]/70 to-transparent pointer-events-none" data-id="element-5" />

        {/* Top Content Area (Safe Zone) */}
        <div className="absolute top-0 inset-x-0 pt-16 px-8 flex flex-col items-center text-center z-10" data-id="element-6">
          <h1 className="font-serif-custom text-3xl sm:text-[2rem] text-[#FFF8F0] leading-[1.2] drop-shadow-lg opacity-0 animate-fade-down delay-200" data-id="element-7">
            Transforma tu hogar
            <br data-id="element-8" />
            <span className="italic text-[#D4A574] font-medium mt-1 block" data-id="element-9">
              en un espacio de calma
            </span>
          </h1>
        </div>

        {/* Bottom Content Area */}
        <div className="absolute bottom-0 inset-x-0 pb-12 px-8 flex flex-col items-center text-center z-10" data-id="element-10">
          {/* Supporting Text */}
          <p className="font-sans-custom text-[#FFF8F0]/90 text-sm sm:text-base mb-5 font-medium tracking-wide drop-shadow-md opacity-0 animate-fade-up delay-500" data-id="element-11">
            7 días para reconectar con tu familia
          </p>

          {/* CTA Button */}
          <a href="https://www.serlumi.com/cart/47406312128675:1" target="_blank" rel="noopener noreferrer" className="w-full max-w-[280px] py-4 px-8 bg-[#C4704B] hover:bg-[#A35D3E] text-[#FFF8F0] rounded-full font-sans-custom font-semibold text-base tracking-wide transition-all duration-300 transform hover:scale-105 hover:shadow-[0_8px_25px_rgba(196,112,75,0.5)] shadow-[0_4px_15px_rgba(0,0,0,0.2)] opacity-0 animate-fade-up delay-700 active:scale-95 text-center inline-block no-underline" data-id="element-12">
            Descubre el método
          </a>

          {/* Subtle indicator for swipe/scroll (optional polish) */}
          <div className="mt-6 w-12 h-1.5 bg-white/20 rounded-full opacity-0 animate-fade-up delay-700" data-id="element-13" />
        </div>
      </div>
    </div>;
}